module.exports = __webpack_public_path__ + "static/media/Christvineyard.2f0212b0.png";